var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-emails-mail-message-list-expand"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('general.email.message'))+":")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.sentMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }